import React, { useState } from "react";
import { Container, Navbar, Dropdown } from "react-bootstrap";
import "./header.scss";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { clearUser } from "../../state/reducers/authReducer";

const Header = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  const isAdmin = user?.role === "admin";
  console.log("isAdmin", isAdmin);

  const handleUserClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleProfileNavigate = () => {
    navigate("/profile");
    setShowDropdown(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(clearUser());
    navigate("/login");
  };

  if (!isLoggedIn) {
    return null;
  }

  const menuItems = [
    { to: "/live-testing", label: "Live Testing" },
    { to: "/premium-features", label: "Premium Features" },
    { to: "/case-scenarios", label: "Case Scenarios" },
    { to: "/pricing-details", label: "Pricing Details" },
    { to: "/faq", label: "FAQ" },
  ];

  return (
    <Container fluid className="header-container">
      <header className="top-header">
        <div className="header-left">
          <Navbar.Brand href="/" className="logo">
            CodeCrafter
          </Navbar.Brand>
        </div>
        <div className="header-right">
          <div className="main-menu">
            <ul className="nav-menu">
              {menuItems.map(({ to, label }) => (
                <li key={to}>
                  <Link 
                    to={to} 
                    className={location.pathname === to ? "active-link" : ""}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>  
          </div>
          <div className="user-menu position-relative">
            <Dropdown show={showDropdown} onToggle={setShowDropdown}>
              <Dropdown.Toggle 
                as="button"
                className="user"
                onClick={handleUserClick}
                aria-label="View Profile"
              >
                {user?.fullname
                  ?.split(" ")
                  .map(name => name.charAt(0).toUpperCase())
                  .join("")}
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="user-dropdown">
                <div className="view-user-details">
                  <div className="view-user-img">
                    {user?.fullname
                      ?.split(" ")
                      .map(name => name.charAt(0).toUpperCase())
                      .join("")}
                  </div>
                  <div className="view-user-name">{user?.fullname}</div>
                  <button
                    className="view-profile-btn"
                    onClick={handleProfileNavigate}
                    aria-label="View Profile"
                  >
                    View Profile
                  </button>
                </div>
                <div className="dropdown-menu-list mt-3">
                  <Dropdown.Item onClick={() => navigate("/settings/change-password")}>
                    Change Password
                  </Dropdown.Item>
                  {isAdmin && (
                    <Dropdown.Item onClick={() => navigate("/settings/user-list")}>
                      Users List
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item onClick={() => navigate("/conversion-history")}>
                    Conversion History
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/feedback")}>
                    Feedback
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleLogout}>
                    Logout
                  </Dropdown.Item>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            <div className="header-user-info d-flex flex-column">
              <span className="user-name">{user?.fullname}</span>
              <span className="user-role">{user?.role}</span>
            </div>
          </div>
        </div>
      </header>
    </Container>
  );
};

export default Header;